import { _ } from "../polyglot/polyglot.js";
import { bugfixes, improvements, newFeatures } from "./releaseNotes.js";
import { checkIcon } from "../elements/icons/icons.js";
import { iconAndText } from "../elements/index.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import button from "@foretagsplatsen/finsit-design-system/widget-js/elements/button";

/**
 * Widget rendering the summary of release notes.
 *
 * @param {function} [onRedirectionRequest] - Callback called when the user
 *   clicks on the link to check out the detailed release notes
 */
export default class ReleaseNotesSummaryWidget extends Widget {
	constructor({ onRedirectionRequest = () => {} } = {}) {
		super(...arguments);

		this._onRedirectionRequest = onRedirectionRequest;
	}

	renderContentOn(html) {
		html.div(
			{ class: "ReleaseNotesSummaryWidget" },
			_("New features"),
			this._notesRenderer(this._makeSummaryNotes()),
			button(
				{
					link: true,
					onClick: () => this._onRedirectionRequest(),
					dataTest: "link",
				},
				_("Check out what's new"),
			),
		);
	}

	_makeSummaryNotes() {
		const bugfixNumber = bugfixes.length;
		const newFeaturesNumber = newFeatures.length;
		const improvementsNumber = improvements.length;

		const notes = [];

		if (newFeaturesNumber)
			notes.push(this._featuresSummaryRenderer({ newFeaturesNumber }));

		if (improvementsNumber)
			notes.push(
				this._improvementSummaryRenderer({ improvementsNumber }),
			);

		if (bugfixNumber)
			notes.push(this._bugfixSummaryRenderer({ bugfixNumber }));

		return notes;
	}

	_featuresSummaryRenderer({ newFeaturesNumber }) {
		return _(
			"{newFeaturesNumber} feature added",
			"{newFeaturesNumber} features added",
			newFeaturesNumber,
			{ newFeaturesNumber },
		);
	}

	_improvementSummaryRenderer({ improvementsNumber }) {
		return _(
			"{improvementsNumber} improvement finished",
			"{improvementsNumber} improvements finished",
			improvementsNumber,
			{ improvementsNumber },
		);
	}

	_bugfixSummaryRenderer({ bugfixNumber }) {
		return _(
			"{bugfixNumber} fix completed",
			"{bugfixNumber} fixes completed",
			bugfixNumber,
			{ bugfixNumber },
		);
	}

	_notesRenderer(notes) {
		return (html) =>
			html.ul(...notes.map((note) => this._noteRenderer(note)));
	}

	_noteRenderer(note) {
		return (html) =>
			html.li({ class: "note" }, iconAndText({ icon: checkIcon }, note));
	}
}
